import * as React from 'react'

import { ReactComponent as ArrowDownIcon } from '../../../Assets/arrowDown.svg'
import { ReactComponent as ArrowUpIcon } from '../../../Assets/arrowUp.svg'
import { useDeviceDetector } from '../../../Hooks/useDeviceDetector'
import Paragraph from '../../atoms/Paragraph'

interface Props {
  content?: any
  selectedData?: any
  setSelectedData?: any
}

/**
 * TabSelector Component
 */

const TabSelector = ({ content, selectedData, setSelectedData }: Props) => {
  const { isMobile } = useDeviceDetector()

  const toggleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setSelectedData(e.target.textContent)
  }

  const toggleMobileTabs = (e: any) => {
    e.stopPropagation()
    const parentEle = e.target.closest('.mobileSelectedTab')
    parentEle.classList.toggle('active')
    parentEle.nextElementSibling.classList.toggle('active')
  }

  const selectTab = (e: any) => {
    e.stopPropagation()
    const parentEle = e.target.closest('.tabs')
    const tabSelector = e.target.closest('.mobileTab')
    const mobileSelectedTab = tabSelector.querySelector('.mobileSelectedTab')
    const text = parentEle.children[0].textContent
    mobileSelectedTab.querySelector('.selected p').innerHTML = text
    mobileSelectedTab.classList.toggle('active')
    mobileSelectedTab.nextElementSibling.classList.toggle('active')
    setSelectedData(text)
  }
  return (
    <div className="tabSelector">
      <div className={`tabHeading flex`}>
        {!isMobile ? (
          <>
            {content?.map((item, index) => (
              <div
                key={`${item}-${index}`}
                className={`tabs cursor-pointer overflow-hidden border border-neutral-50 px-24 py-16 ${content.length === 1 ? 'rounded-lg' : index === 0 ? 'rounded-bl-lg rounded-tl-lg border-r' : index === content?.length - 1 ? 'border-r-none rounded-br-lg rounded-tr-lg' : ''} ${selectedData === item ? 'active' : ''}`}
                onClick={(e) => {
                  toggleClick(e)
                }}
              >
                <Paragraph content={item} />
              </div>
            ))}
          </>
        ) : (
          <div className={`mobileTab relative w-full`}>
            <div
              className={`mobileSelectedTab flex items-center justify-between overflow-hidden rounded-lg border border-neutral-50 p-16`}
              onClick={(e) => {
                toggleMobileTabs(e)
              }}
            >
              <div className={`selected flex cursor-pointer items-center justify-start gap-12`}>
                <Paragraph content={selectedData} />
              </div>
              <div className="">
                <ArrowUpIcon />
                <ArrowDownIcon />
              </div>
            </div>
            <div
              className={`mobileTabHeading absolute left-0 top-full z-10 flex w-full flex-col overflow-hidden rounded-bl-lg rounded-br-lg border border-neutral-50 bg-white shadow-xl`}
            >
              {content?.map((item, index) => (
                <>
                  <div
                    key={`${item}-${index}`}
                    className={`tabs cursor-pointer border border-t-0 border-neutral-50 p-16`}
                    onClick={(e) => {
                      selectTab(e)
                    }}
                  >
                    <Paragraph content={item} />
                  </div>
                </>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default TabSelector
